import { useMemo } from 'react'

import { useCurrentUser } from 'hooks/useCurrentUser'
import { useGroup } from 'hooks/useGroup'
import { useSubscriptions } from 'hooks/useSubscriptions'

export const useSubscribed = ({ programId }: { programId?: string }) => {
  const { data: currentUser } = useCurrentUser()
  const { data: group } = useGroup({ groupId: programId })
  const { data: subscriptions, isLoading } = useSubscriptions({ trainerId: group?.trainer?.id })

  const isSubscribed = useMemo((): boolean => {
    return !!subscriptions?.find((sub) => sub.user.id === currentUser?.id)
  }, [subscriptions, currentUser])

  return {
    isSubscribed,
    isLoading,
  }
}
